'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useState, useCallback } from 'react';
import { Button, Spinner } from '~/components/primitives';
import ReactPlayer from 'react-player';
import { cx } from 'class-variance-authority';
import { getVideoThumbnails } from '~/utils/video';
import Image from 'next/image';
function Video(t0) {
  const $ = _c(33);
  const {
    src,
    className,
    autoPlay: t1,
    loop: t2,
    muted: t3,
    buttonText,
    children
  } = t0;
  const autoPlay = t1 === undefined ? false : t1;
  const loop = t2 === undefined ? false : t2;
  const muted = t3 === undefined ? false : t3;
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [poster, setPoster] = useState(null);
  let t4;
  if ($[0] !== autoPlay) {
    t4 = autoPlay && {
      autoPlay
    };
    $[0] = autoPlay;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== loop) {
    t5 = loop && {
      loop
    };
    $[2] = loop;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== muted) {
    t6 = muted && {
      muted
    };
    $[4] = muted;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t4 || $[7] !== t5 || $[8] !== t6) {
    t7 = {
      ...t4,
      ...t5,
      ...t6
    };
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const optionalProps = t7;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setIsPlaying(_temp);
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const toggleVideo = t8;
  const hasWindow = typeof window !== "undefined";
  let t10;
  let t9;
  if ($[11] !== src) {
    t9 = () => {
      getVideoThumbnails(src).then(thumbnails => setPoster(thumbnails.large)).catch(_temp2);
    };
    t10 = [src];
    $[11] = src;
    $[12] = t10;
    $[13] = t9;
  } else {
    t10 = $[12];
    t9 = $[13];
  }
  useEffect(t9, t10);
  let t11;
  if ($[14] !== className || $[15] !== isLoading || $[16] !== poster) {
    t11 = isLoading && poster && <div className={cx("relative mx-auto w-full overflow-hidden", className)} style={{
      aspectRatio: "16/9"
    }}><Image src={poster} alt="Video thumbnail" fill={true} className="object-cover" /><div className="absolute top-1/2 left-1/2 z-1 -translate-x-1/2 -translate-y-1/2 transform"><Spinner className="h-4 w-4 text-white" /></div></div>;
    $[14] = className;
    $[15] = isLoading;
    $[16] = poster;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== className || $[19] !== isLoading || $[20] !== isPlaying || $[21] !== optionalProps || $[22] !== src) {
    t12 = hasWindow && <div className={isLoading ? "hidden" : "block"}><ReactPlayer url={src} onClick={toggleVideo} controls={false} playing={isPlaying} className={cx("relative mx-auto w-full overflow-hidden", className)} style={{
        aspectRatio: "16/9"
      }} width="100%" height="100%" onEnded={() => setIsPlaying(false)} onReady={() => setIsLoading(false)} config={{
        file: {
          attributes: {
            preload: "auto"
          }
        },
        youtube: {
          playerVars: {
            controls: 0
          }
        }
      }} {...optionalProps} /></div>;
    $[18] = className;
    $[19] = isLoading;
    $[20] = isPlaying;
    $[21] = optionalProps;
    $[22] = src;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== buttonText || $[25] !== isLoading || $[26] !== isPlaying) {
    t13 = !isLoading && buttonText && !isPlaying && <><button type="button" className="absolute inset-0" onClick={toggleVideo}><span className="sr-only">{buttonText}</span></button><Button variant="tertiary" onClick={toggleVideo} iconBefore="play" className="absolute top-1/2 left-1/2 z-1 -translate-x-1/2 -translate-y-1/2 transform">{buttonText}</Button></>;
    $[24] = buttonText;
    $[25] = isLoading;
    $[26] = isPlaying;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== children || $[29] !== t11 || $[30] !== t12 || $[31] !== t13) {
    t14 = <div className="relative">{t11}{t12}{t13}{children}</div>;
    $[28] = children;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
}
function _temp2(error) {
  console.warn("Failed to generate thumbnails:", error);
}
function _temp(prev) {
  return !prev;
}
export default Video;